import { createReducer, INITIAL_STATE } from '@shared/redux';
import { WithDataFetchParams } from '@shared/redux/commons.types';
import { LOAD_STATE } from '@shared/axios/axios.constants';
import { formatClusterData } from '@domain/omnichannel-budget-manager/omnichannel-budget-manager.utils';
import { listClustersConfig } from './clusters.api';

export const HANDLE_GET_CLUSTERS = '@omnichannel-budget-manager/HANDLE_GET_CLUSTERS';

export const LIST_CLUSTERS_REQUEST_CALLED = '@omnichannel-budget-manager/LIST_CLUSTERS_REQUEST_CALLED';
export const LIST_CLUSTERS_REQUEST_SUCCEEDED = '@omnichannel-budget-manager/LIST_CLUSTERS_REQUEST_SUCCEEDED';
export const LIST_CLUSTERS_REQUEST_FAILED = '@omnichannel-budget-manager/LIST_CLUSTERS_REQUEST_FAILED';
export const LIST_CLUSTERS_REQUEST_CANCELED = '@omnichannel-budget-manager/LIST_CLUSTERS_REQUEST_CANCELED';

export const getClientClusters = state => state.omnichannelBudgetManager.clusters;

export const handleGetClusters = () => ({
    type: HANDLE_GET_CLUSTERS,
    payload: {},
});

export const SET_CLUSTERS = '@clusters/SET_CLUSTERS';

export const getClusters = state => state.omnichannelBudgetManager.clusters.data;
export const getClustersState = state => state.omnichannelBudgetManager.clusters.loadState;

export const listClusters = ({
    clientId,
    organizationId,
}) => ({
    type: LIST_CLUSTERS_REQUEST_CALLED,
    actionTypes: {
        success: LIST_CLUSTERS_REQUEST_SUCCEEDED,
        fail: LIST_CLUSTERS_REQUEST_FAILED,
        canceled: LIST_CLUSTERS_REQUEST_CANCELED,
    },
    config: listClustersConfig({
        clientId,
        organizationId,
    }),
});

export const setListClusters = values => ({
    type: SET_CLUSTERS,
    payload: values,
});

const initialState: WithDataFetchParams<any> = {
    data: [],
    loadState: LOAD_STATE.LOADING,
    error: null,
};

export const clustersReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [LIST_CLUSTERS_REQUEST_CALLED]: state => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [LIST_CLUSTERS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: formatClusterData(action.payload.data),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [LIST_CLUSTERS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [LIST_CLUSTERS_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [SET_CLUSTERS]: (state, action) => ({
        ...state,
        data: action.payload,
    }),
});
